import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Select from "react-select";
import { useFormik } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { adminMainUrl } from "../../../../../../Config";
import { getJobOrderCargoDetail } from "../../../../../../Redux/action/Joborder/JoborderAction";


const EditCargoDlts = ({
  showAdd,
  handleCloseAdd,
  token,
  user_id,
  b64id,
  loadingJobOrderCommodityList,
  JobOrderCommodityList,
  refreshCargoDtls,
  cargoDtls_id,
  transmode,    // new: "Air" or "Sea"
  transtype     // new: "Import" or "Export"
}) => {

  const dispatch = useDispatch();

  useEffect(() => {
    if (token && user_id && b64id && cargoDtls_id) {
      let id = atob(b64id);
      if (id) {
        dispatch(getJobOrderCargoDetail(token, user_id, id, cargoDtls_id));
      }
    }
  }, [cargoDtls_id]);


  const {
    loadingJobOrderCargoDetail,
    JobOrderCargoDetail,
    JobOrderCargoDetailError,
  } = useSelector(state => state?.JoborderReducer);


  const [disableSubmit, setDisableSubmit] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [employeeOptions, setEmployeeOptions] = useState([]);


  const [commodityOptions, setCommodityOptions] = useState([]);
  useEffect(() => {
    if (JobOrderCommodityList) {
      let arr = [];
      JobOrderCommodityList.map(val => { arr.push({ value: val.id, label: val.name }) });
      setCommodityOptions(arr);
    }
  }, [loadingJobOrderCommodityList, JobOrderCommodityList]);


  const initialValues = {
    description: "",
    packages_type: "",
    packages_count: "",
    commodity_id: "",
    inner_pkgs_type: "",
    inner_pkgs_count: "",
    commodity_type: "",
    gross_weight_type: "",
    gross_weight: "",
    hs_code: "",
    net_weight_type: "",
    net_weight: "",
    dimension_type: "",
    dimension_length: "",
    dimension_height: "",
    dimension_width: "",
    volume_type: "",
    total_volume: "",
    volume_weight: "",
    marks_and_nos: "",
    chargeable_wt: "",
    chargeable_wt_type: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => {
      // console.log(values);
      setDisableSubmit(true);
      try {
        let config = {
          headers: {
            "auth-token": token,
            user_id: user_id,
          },
        };
        values.job_order_id = atob(b64id);
        if (!cargoDtls_id) {
          toast.error("Couldn't get update id.")
          return;
        } else {
          values.id = cargoDtls_id
        }
        axios
          .post(`${adminMainUrl}/api/jobOrder/cargo/update`, values, config)
          .then((response) => {
            if (response.status == 200) {
              toast.success(response?.data?.msg);
              setDisableSubmit(false);
              handleCloseAdd();
              refreshCargoDtls();
              // refresh();
              // refreshCargo();
            } else {
              toast.error(response?.data?.msg);
              setDisableSubmit(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error.response.data.msg);
            setDisableSubmit(false);
          });
      } catch (error) {
        console.log(error.message);
        toast.error(error.message);
        setDisableSubmit(false);
      }
    },
  });


  useEffect(() => {

    if (loadingJobOrderCargoDetail) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }


    if (JobOrderCargoDetail) {
      // console.log("JobOrderCargoDetail", JobOrderCargoDetail);
      formik.setFieldValue("description", JobOrderCargoDetail?.description);
      formik.setFieldValue("packages_type", JobOrderCargoDetail?.packages_type);
      formik.setFieldValue("packages_count", JobOrderCargoDetail?.packages_count);
      formik.setFieldValue("commodity_id", JobOrderCargoDetail?.commodity_id);
      formik.setFieldValue("inner_pkgs_type", JobOrderCargoDetail?.inner_pkgs_type);
      formik.setFieldValue("inner_pkgs_count", JobOrderCargoDetail?.inner_pkgs_count);
      formik.setFieldValue("commodity_type", JobOrderCargoDetail?.commodity_type);
      formik.setFieldValue("gross_weight_type", JobOrderCargoDetail?.gross_weight_type);
      formik.setFieldValue("gross_weight", JobOrderCargoDetail?.gross_weight);
      formik.setFieldValue("hs_code", JobOrderCargoDetail?.hs_code);
      formik.setFieldValue("net_weight_type", JobOrderCargoDetail?.net_weight_type);
      formik.setFieldValue("net_weight", JobOrderCargoDetail?.net_weight);
      formik.setFieldValue("dimension_type", JobOrderCargoDetail?.dimension_type);
      formik.setFieldValue("dimension_length", JobOrderCargoDetail?.dimension_length);
      formik.setFieldValue("dimension_height", JobOrderCargoDetail?.dimension_height);
      formik.setFieldValue("dimension_width", JobOrderCargoDetail?.dimension_width);
      formik.setFieldValue("volume_type", JobOrderCargoDetail?.volume_type);
      formik.setFieldValue("total_volume", JobOrderCargoDetail?.total_volume);
      formik.setFieldValue("volume_weight", JobOrderCargoDetail?.volume_weight);
      formik.setFieldValue("marks_and_nos", JobOrderCargoDetail?.marks_and_nos);
      formik.setFieldValue("chargeable_wt", JobOrderCargoDetail?.chargeable_wt);
      formik.setFieldValue("chargeable_wt_type", JobOrderCargoDetail?.chargeable_wt_type);
    }

  }, [loadingJobOrderCargoDetail, JobOrderCargoDetail,])

  // ================== VOLUME & VOLUME WEIGHT CALCULATIONS (same as AddCargo) ==================
  const convertVolumeFromCBM = (cbm, targetUnit) => {
    if (!cbm && cbm !== 0) return "";
    const val = parseFloat(cbm);
    if (isNaN(val)) return "";
    switch (targetUnit) {
      case "CBM": return val;
      case "CFT": return val * 35.3147;
      case "CBI": return val * 61023.7;
      case "CCM": return val * 1000000;
      case "LTR": return val * 1000;
      case "KLT": return val;
      case "PNT": return val * 2113.38;
      case "UGS": return val * 264.172;
      default: return val;
    }
  };

  const convertVolumeToCBM = (value, fromUnit) => {
    if (!value && value !== 0) return 0;
    const val = parseFloat(value);
    if (isNaN(val)) return 0;
    switch (fromUnit) {
      case "CBM": return val;
      case "CFT": return val / 35.3147;
      case "CBI": return val / 61023.7;
      case "CCM": return val / 1000000;
      case "LTR": return val / 1000;
      case "KLT": return val;
      case "PNT": return val / 2113.38;
      case "UGS": return val / 264.172;
      default: return val;
    }
  };

  // Auto-calculate volume and volume weight when dimension inputs change
  useEffect(() => {
    const length = parseFloat(formik.values.dimension_length) || 0;
    const width = parseFloat(formik.values.dimension_width) || 0;
    const height = parseFloat(formik.values.dimension_height) || 0;
    const quantity = parseFloat(formik.values.packages_count) || 1;
    const dimUnit = formik.values.dimension_type;

    if (length > 0 && width > 0 && height > 0 && quantity > 0) {
      let volumeInCBM = 0;
      if (dimUnit === "CMS") {
        volumeInCBM = (length * width * height * quantity) / 1000000;
      } else if (dimUnit === "INC") {
        volumeInCBM = (length * width * height * quantity) / 61023.744;
      } else if (dimUnit === "MTR") {
        volumeInCBM = (length * width * height * quantity);
      }
      const volumeUnit = formik.values.volume_type;
      const converted = convertVolumeFromCBM(volumeInCBM, volumeUnit);
      if (converted !== "") {
        formik.setFieldValue("total_volume", converted.toFixed(3));
      } else {
        formik.setFieldValue("total_volume", "");
      }

      let volumetricWeightInKgs = 0;
      if (dimUnit === "CMS") {
        volumetricWeightInKgs = (length * width * height * quantity) / 6000;
      } else if (dimUnit === "INC") {
        volumetricWeightInKgs = (length * width * height * quantity) / 366;
      } else if (dimUnit === "MTR") {
        volumetricWeightInKgs = (length * width * height * quantity * 1000000) / 6000;
      }
      formik.setFieldValue("volume_weight", volumetricWeightInKgs.toFixed(2));
    } else {
      if (!formik.values.total_volume) formik.setFieldValue("total_volume", "");
      if (!formik.values.volume_weight) formik.setFieldValue("volume_weight", "");
    }
  }, [
    formik.values.dimension_length,
    formik.values.dimension_width,
    formik.values.dimension_height,
    formik.values.dimension_type,
    formik.values.packages_count,
    formik.values.volume_type,
  ]);
  // =====================================================================

  // (The second useEffect that sets fields is redundant but we keep it as per "do not remove any line of code")
  useEffect(() => {
    if (loadingJobOrderCargoDetail) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }

    if (JobOrderCargoDetail) {
      formik.setFieldValue("description", JobOrderCargoDetail?.description);
      formik.setFieldValue("packages_type", JobOrderCargoDetail?.packages_type);
      formik.setFieldValue(
        "packages_count",
        JobOrderCargoDetail?.packages_count
      );
      formik.setFieldValue("commodity_id", JobOrderCargoDetail?.commodity_id);
      formik.setFieldValue(
        "inner_pkgs_type",
        JobOrderCargoDetail?.inner_pkgs_type
      );
      formik.setFieldValue(
        "inner_pkgs_count",
        JobOrderCargoDetail?.inner_pkgs_count
      );
      formik.setFieldValue(
        "commodity_type",
        JobOrderCargoDetail?.commodity_type
      );
      formik.setFieldValue(
        "gross_weight_type",
        JobOrderCargoDetail?.gross_weight_type
      );
      formik.setFieldValue("gross_weight", JobOrderCargoDetail?.gross_weight);
      formik.setFieldValue("hs_code", JobOrderCargoDetail?.hs_code);
      formik.setFieldValue("net_weight", JobOrderCargoDetail?.net_weight);
      formik.setFieldValue(
        "dimension_type",
        JobOrderCargoDetail?.dimension_type
      );
      formik.setFieldValue(
        "dimension_length",
        JobOrderCargoDetail?.dimension_length
      );
      formik.setFieldValue(
        "dimension_height",
        JobOrderCargoDetail?.dimension_height
      );
      formik.setFieldValue(
        "dimension_width",
        JobOrderCargoDetail?.dimension_width
      );
      formik.setFieldValue("volume_type", JobOrderCargoDetail?.volume_type);
      formik.setFieldValue("total_volume", JobOrderCargoDetail?.total_volume);
      formik.setFieldValue("volume_weight", JobOrderCargoDetail?.volume_weight);
      formik.setFieldValue("marks_and_nos", JobOrderCargoDetail?.marks_and_nos);
      formik.setFieldValue("chargeable_wt", JobOrderCargoDetail?.chargeable_wt);
    }
  }, [
    loadingJobOrderCargoDetail,
    JobOrderCargoDetailError,
    JobOrderCargoDetail,
    employeeOptions,
  ]);

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 29,
      minHeight: 29,
      display: 'flex',
      alignItems: 'center',
    }),
    placeholder: (base) => ({
      ...base,
      display: 'flex',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: "600",
      color: '#808080',
    }),
    menu: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    option: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '12px',
      display: 'flex',
      alignItems: 'center',
    }),
  };

  // Condition to hide Gross/Net Weight for Air Export
  const hideWeightFields = (transmode === "Air" && transtype === "Export");

  return (
    <>
      <Offcanvas show={showAdd} onHide={handleCloseAdd} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Cargo Dtls</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={formik.handleSubmit}>
          <div className="row">
              {/* Description */}
              <div className="col-md-12 mt-2">
                <label htmlFor="description" className="form-label ">
                  Description
                </label>
                <textarea
                  className="form-control "
                  id="description"
                  maxLength={250}
                  rows={3}
                  name="description"
                  onChange={(e) => {
                    formik.setFieldValue("description", e.target.value);
                  }}
                  value={formik.values.description}
                ></textarea>
              </div>
              {/* Packages */}
              <div className="col-md-6 mt-2">
                <label htmlFor="packages" className="form-label ">
                  Packages
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={15}
                    className="form-control form-control-sm"
                    id="packages_count"
                    name="packages_count"
                    onChange={(e) => {
                      formik.setFieldValue("packages_count", e.target.value);
                    }}
                    value={formik.values.packages_count}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9]/g, '');
                      event.target.value = value;
                    }}

                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="packages_type"
                    name="packages_type"
                    onChange={(e) => {
                      formik.setFieldValue("packages_type", e.target.value);
                    }}
                    value={formik.values.packages_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
                </div>
              </div>
              {/* Inner Packages */}
              <div className="col-md-6 mt-2">
                <label htmlFor="inner_packages" className="form-label ">
                  Inner Pkgs
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={15}
                    className="form-control form-control-sm"
                    id="inner_pkgs_count"
                    name="inner_pkgs_count"
                    onChange={(e) => {
                      formik.setFieldValue("inner_pkgs_count", e.target.value);
                    }}
                    value={formik.values.inner_pkgs_count}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9]/g, '');
                      event.target.value = value;
                    }}

                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="inner_pkgs_type"
                    name="inner_pkgs_type"
                    onChange={(e) => {
                      formik.setFieldValue("inner_pkgs_type", e.target.value);
                    }}
                    value={formik.values.inner_pkgs_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
                </div>
              </div>

              {/* ── Gross Weight (hidden for Air Export) ── */}
              {!hideWeightFields && (
                <div className="col-md-6 mt-2">
                  <label htmlFor="gross_weight" className="form-label ">
                    Gross Weight
                  </label>
                  <div className="d-flex">
                    <input
                      type="text"
                      maxLength={20}
                      className="form-control form-control-sm"
                      id="gross_weight"
                      name="gross_weight"
                      onChange={(e) => {
                        formik.setFieldValue("gross_weight", e.target.value);
                      }}
                      value={formik.values.gross_weight}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9.]/g, '');
                        const parts = value.split('.');
                        if (parts.length > 2) {
                          value = parts[0] + '.' + parts[1];
                        }
                        event.target.value = value;
                      }}
                    />
                    <select
                      className="form-control form-control-sm ms-2"
                      id="gross_weight_type"
                      name="gross_weight_type"
                      onChange={(e) => {
                        formik.setFieldValue("gross_weight_type", e.target.value);
                      }}
                      value={formik.values.gross_weight_type}
                    >
                      <option value="" disabled>-</option>
                      <option value="CAR">CAR (Carat)</option>
                      <option value="CTM">CTM (CARATS)</option>
                      <option value="GMS">GMS (Gram)</option>
                      <option value="KGS">KGS (Kilogram)</option>
                      <option value="LBS">LBS (POUNDS)</option>
                      <option value="MGR">MGR (Milligram)</option>
                      <option value="MTS">MTS (Metric Ton)</option>
                      <option value="PND">PND (Pound)</option>
                      <option value="QTL">QTL (Quintal)</option>
                      <option value="TGM">TGM (Ten Gross)</option>
                      <option value="TON">TON (Long Ton)</option>
                    </select>
                  </div>
                </div>
              )}

              {/* ── Net Weight (hidden for Air Export) ── */}
              {!hideWeightFields && (
                <div className="col-md-6 mt-2">
                  <label htmlFor="net_weight" className="form-label ">
                    Net Weight
                  </label>
                  <div className="d-flex">
                    <input
                      type="text"
                      maxLength={20}
                      className="form-control form-control-sm"
                      id="net_weight"
                      name="net_weight"
                      onChange={(e) => {
                        formik.setFieldValue("net_weight", e.target.value);
                      }}
                      value={formik.values.net_weight}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9.]/g, '');
                        const parts = value.split('.');
                        if (parts.length > 2) {
                          value = parts[0] + '.' + parts[1];
                        }
                        event.target.value = value;
                      }}
                    />
                    <select
                      className="form-control form-control-sm ms-2"
                      id="net_weight_type"
                      name="net_weight_type"
                      onChange={(e) => {
                        formik.setFieldValue("net_weight_type", e.target.value);
                      }}
                      value={formik.values.net_weight_type}
                    >
                      <option value="" disabled>-</option>
                      <option value="CAR">CAR (Carat)</option>
                      <option value="CTM">CTM (CARATS)</option>
                      <option value="GMS">GMS (Gram)</option>
                      <option value="KGS">KGS (Kilogram)</option>
                      <option value="LBS">LBS (POUNDS)</option>
                      <option value="MGR">MGR (Milligram)</option>
                      <option value="MTS">MTS (Metric Ton)</option>
                      <option value="PND">PND (Pound)</option>
                      <option value="QTL">QTL (Quintal)</option>
                      <option value="TGM">TGM (Ten Gross)</option>
                      <option value="TON">TON (Long Ton)</option>
                    </select>
                  </div>
                </div>
              )}

              {/* Dimension – same UI as AddCargo */}
              <div className="col-md-6 mt-2">
                <label htmlFor="dimension" className="form-label">
                  Dimension
                </label>
                <div className="d-flex align-items-start">
                  <div className="text-center me-1" style={{ width: '80px' }}>
                    <input
                      type="text"
                      maxLength={15}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9.]/g, '');
                        const parts = value.split('.');
                        if (parts.length > 2) value = parts[0] + '.' + parts[1];
                        event.target.value = value;
                      }}
                      className="form-control form-control-sm text-center"
                      id="dimension_length"
                      placeholder={0.0}
                      name="dimension_length"
                      onChange={(e) => formik.setFieldValue("dimension_length", e.target.value)}
                      value={formik.values.dimension_length}
                    />
                    <small className="text-muted">L</small>
                  </div>

                  <span className="mx-1" style={{ marginTop: '7px' }}>×</span>

                  <div className="text-center me-1" style={{ width: '80px' }}>
                    <input
                      type="text"
                      maxLength={15}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9.]/g, '');
                        const parts = value.split('.');
                        if (parts.length > 2) value = parts[0] + '.' + parts[1];
                        event.target.value = value;
                      }}
                      className="form-control form-control-sm text-center"
                      id="dimension_width"
                      placeholder={0.0}
                      name="dimension_width"
                      onChange={(e) => formik.setFieldValue("dimension_width", e.target.value)}
                      value={formik.values.dimension_width}
                    />
                    <small className="text-muted">B</small>
                  </div>

                  <span className="mx-1" style={{ marginTop: '7px' }}>×</span>

                  <div className="text-center me-2" style={{ width: '80px' }}>
                    <input
                      type="text"
                      maxLength={15}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9.]/g, '');
                        const parts = value.split('.');
                        if (parts.length > 2) value = parts[0] + '.' + parts[1];
                        event.target.value = value;
                      }}
                      className="form-control form-control-sm text-center"
                      id="dimension_height"
                      placeholder={0.0}
                      name="dimension_height"
                      onChange={(e) => formik.setFieldValue("dimension_height", e.target.value)}
                      value={formik.values.dimension_height}
                    />
                    <small className="text-muted">H</small>
                  </div>

                  <div className="ms-2" style={{ minWidth: '100px' }}>
                    <select
                      className="form-control form-control-sm"
                      id="dimension_type"
                      name="dimension_type"
                      onChange={(e) => formik.setFieldValue("dimension_type", e.target.value)}
                      value={formik.values.dimension_type}
                    >
                      <option value="" disabled>unit</option>
                      <option value="CMS">CMS</option>
                      <option value="INC">INC</option>
                      <option value="MTR">MTR</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Volume */}
              <div className="col-md-6 mt-2">
                <label htmlFor="volume" className="form-label ">
                  Volume
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={20}
                    className="form-control form-control-sm"
                    id="total_volume"
                    name="total_volume"
                    onChange={(e) => {
                      formik.setFieldValue("total_volume", e.target.value);
                    }}
                    value={formik.values.total_volume}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}
                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="volume_type"
                    name="volume_type"
                    onChange={(e) => {
                      formik.setFieldValue("volume_type", e.target.value);
                    }}
                    value={formik.values.volume_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="CBI">CBI (Cubic Inch)</option>
                    <option value="CBM">CBM (Cubic metre)</option>
                    <option value="CCM">CCM (Cubic Centimetre)</option>
                    <option value="CFT">CFT (Cubic foot)</option>
                    <option value="KLT">KLT (Kilo Litre)</option>
                    <option value="LTR">LTR (Litre)</option>
                    <option value="PNT">PNT (Pint)</option>
                    <option value="UGS">UGS (US Gallons)</option>
                  </select>
                </div>
              </div>

              {/* Commodity */}
              <div className="col-md-6 mt-2">
                <label htmlFor="commodity" className="form-label ">
                  Commodity
                </label>
                <Select
                  id="commodity_id"
                  placeholder="Select Commodity"
                  className='custom-selector w-100'
                  options={commodityOptions}
                  styles={customStyles}
                  name="commodity_id"
                  onChange={option => {
                    formik.setFieldValue('commodity_id', option.value);
                  }}
                  value={commodityOptions.find(option => option.value === formik.values.commodity_id) || null}
                />

              </div>
              {/* Commodity Type */}
              <div className="col-md-6 mt-2">
                <label htmlFor="commodity_type" className="form-label ">
                  Commodity Type
                </label>
                <select
                  className="form-control form-control-sm"
                  id="commodity_type"
                  name="commodity_type"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.commodity_type}
                >
                  <option value="" disabled>-</option>
                  <option value="Non-Hazardous" >Non-Hazardous</option>
                  <option value="Hazardous">Hazardous</option>
                  <option value="Perishable">Perishable</option>
                </select>
              </div>
              {/* HS Code */}
              <div className="col-md-6 mt-2">
                <label htmlFor="hs_code" className="form-label ">
                  HS Code
                </label>
                <input
                  type="text"
                  maxLength={20}
                  className="form-control form-control-sm"
                  id="hs_code"
                  name="hs_code"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.hs_code}
                />
              </div>
              {/* Volume Weight */}
              <div className="col-md-6 mt-2">
                <label htmlFor="volume_weight" className="form-label ">
                  Volume Weight
                </label>
                <input
                  type="text"
                  maxLength={20}
                  className="form-control form-control-sm"
                  id="volume_weight"
                  step="0.001"
                  placeholder={0.0}
                  name="volume_weight"
                  onChange={formik.handleChange}
                  value={formik.values.volume_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts[1];
                    }
                    event.target.value = value;
                  }}
                />
              </div>
              {/* Chargeable Weight */}
              <div className="col-md-6 mt-2">
                <label htmlFor="chargeable_weight" className="form-label ">
                  Chargeable Wt
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={20}
                    className="form-control form-control-sm"
                    id="chargeable_wt"
                    step="0.001"
                    placeholder={0.0}
                    name="chargeable_wt"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.chargeable_wt}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}
                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="chargeable_wt_type"
                    name="chargeable_wt_type"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.chargeable_wt_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="KGS">KGS</option>
                    <option value="MTS">MTS</option>
                  </select>
                </div>
              </div>
             
            </div>
             {/* Marks and Nos */}
              <div className="col-md-12 mt-2">
                <label htmlFor="marks_and_nos" className="form-label ">
                  Marks and Nos
                </label>
                <textarea
                  className="form-control"
                  id="marks_and_nos"
                  maxLength={250}
                  rows={2}
                  name="marks_and_nos"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.marks_and_nos}
                />
              </div>

            <div className="row d-flex justify-content-end my-2">
              <div className="col-md-6 d-flex justify-content-end">
                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                  {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                </button>
              </div>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas >
    </>
  )
}

export default EditCargoDlts